export type Range =
  | 'pax'
  | 'besta'
  | 'platsa'
  | 'eket'
  | 'smastad'
  | 'ivar'
  | 'billy'
  | 'bror'
  | 'kallax'
  | 'boaxel'
  | 'ladmakare'
  | 'jonaxel'
  | 'knoxhult'
  | 'aurdal'
  | 'elvarli';

export const rangeNameMap: Record<Range, string> = {
  pax: 'PAX',
  besta: 'BESTÅ',
  platsa: 'PLATSA',
  eket: 'EKET',
  smastad: 'SMÅSTAD',
  ivar: 'IVAR',
  billy: 'BILLY',
  bror: 'BROR',
  kallax: 'KALLAX',
  boaxel: 'BOAXEL',
  ladmakare: 'LÅDMAKARE',
  jonaxel: 'JONAXEL',
  knoxhult: 'KNOXHULT',
  aurdal: 'AURDAL',
  elvarli: 'ELVARLI'
};

export const rangePrefixMap = Object.fromEntries(
  Object.entries(rangeNameMap).map(([key, name]) => [
    key,
    name.replaceAll(/Ö/g, 'O').replaceAll(/Å|Ä/g, 'A')
  ])
) as Record<Range, string>;
